import React, { useEffect, useRef, useState } from 'react';
import { Card as BCard } from 'react-bootstrap';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Box,
    Button,
    Collapse,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useReactToPrint } from 'react-to-print';
import PrintIcon from '@mui/icons-material/Print';
import CloseIcon from '@mui/icons-material/Close';
import Draggable from 'react-draggable';
import { useMarkdown } from '../../../../hooks/ReactMarkdown';

const useStyles = makeStyles(theme => ({
    traceDialogContent: {
        maxHeight: '450px'
    },
    traceCardHeaderPadding: {
        paddingLeft: "9px"
    },
    traceCardUlPadding: {
        paddingLeft: "33px",
        paddingRight: '10px',
        textAlign: 'justify'
    },
    traceResults: {
        position: 'absolute',
        zIndex: '-10',
        left:'2500px'
    }
}));

function PromptModal({ open, prompt, onClose, close }) {
    const [traceCollapseIndex, setTraceCollapseIndex] = useState(0);
    const [lastActiveSecIndex, setLastActiveSecIndex] = useState(0);

    const classes = useStyles();
    const hiddenDivRef = useRef();

    function PaperComponent(props) {
        return (
            <Draggable
                handle="#advanced-trace-dialog"
                cancel={'[class*="MuiDialogContent-root"]'}
            >
                <Paper {...props} />
            </Draggable>
        );
    }

    return (<>
        <Dialog
            fullWidth
            scroll="paper"
            maxWidth="md"
            open={open}
            PaperComponent={PaperComponent}
            aria-labelledby="advanced-trace-dialog"
            hideBackdrop
        >
            <DialogTitle style={{ cursor: 'move' }} id="advanced-trace-dialog">
                <Grid container alignItems='center'>
                    <Grid item xs={6}>
                        {prompt?.key.
                        toLowerCase().
                        replaceAll('_',' ').
                        replace(/^\w/, (c) => c.toUpperCase()) || 'Prompt Details'}
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: 'right' }}>
                        <IconButton
                            aria-label="close"
                            onClick={()=>{
                                close();
                                onClose();
                            }}
                            size="small">
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent id='trace-dialog-content' dividers className={classes.traceDialogContent} >
                <Grid container spacing={2}>
                    <Grid tabIndex="-1" item md={12}>
                            <BCard variant="outlined">
                                <BCard.Header as="h5" className={classes.traceCardHeaderPadding}>
                                    Prompt Text
                                </BCard.Header>
                                <BCard.Body className='px-0'>
                                    <Box marginTop={1} marginBottom={1} px={2}>
                                            <p>
                                                {useMarkdown({rawMarkdown:prompt?.prompt || 'N/A'})}
                                            </p>
                                        </Box>
                                </BCard.Body>
                            </BCard>
                        </Grid>
                </Grid>
            </DialogContent>

        </Dialog>
    </>);
}

export default PromptModal


